var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.58 212.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".p{fill:#fff;stroke-width:7px;}.p,.q{stroke:#386aff;}.p,.q,.r{stroke-linecap:round;stroke-linejoin:round;}.s{fill:#386aff;}.q,.r{fill:#5da8f6;stroke-width:7px;}.r{stroke:#5da8f6;}.t{fill:#abcfff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M109.79,124.4h65.2c0-17.29-6.87-33.88-19.1-46.1s-28.82-19.1-46.1-19.1V124.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 109.73,
    y1: 185.9,
    x2: 109.74,
    y2: 170.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 78.99,
    y1: 177.63,
    x2: 86.66,
    y2: 164.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 56.5,
    y1: 155.1,
    x2: 69.78,
    y2: 147.45
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 48.29,
    y1: 124.34,
    x2: 63.61,
    y2: 124.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 56.56,
    y1: 93.6,
    x2: 69.83,
    y2: 101.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("line", {
    className: "q",
    x1: 79.1,
    y1: 71.11,
    x2: 86.75,
    y2: 84.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 109.86,
    y1: 62.91,
    x2: 109.84,
    y2: 78.23
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 140.6,
    y1: 71.18,
    x2: 132.92,
    y2: 84.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 163.08,
    y1: 93.71,
    x2: 149.81,
    y2: 101.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 171.29,
    y1: 124.47,
    x2: 155.97,
    y2: 124.45
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 163.02,
    y1: 155.21,
    x2: 149.76,
    y2: 147.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 140.49,
    y1: 177.7,
    x2: 132.84,
    y2: 164.42
  }))), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M107.08,121.46c-1.56,1.56-1.56,4.09,0,5.66h0c1.56,1.56,4.09,1.56,5.66,0l22.89-27.14c.73-.93-.47-2.13-1.41-1.41l-27.14,22.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M117.29,16.78V59.63c-2.46-.29-4.96-.43-7.5-.43s-5.03,.14-7.49,.43V16.78h14.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 85.59,
    y: 3.5,
    width: 48.41,
    height: 16.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M200.09,67.14l-2.11,1.5-31.93,22.79c-1.98-3.37-4.26-6.55-6.79-9.5l31.94-22.79,2.11-1.51,6.78,9.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    x: 180.99,
    y: 53.66,
    width: 37.73,
    height: 12.94,
    transform: "translate(132.71 -137.48) rotate(54.49)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M60.33,81.93c-2.54,2.95-4.82,6.13-6.8,9.5l-31.92-22.79-2.11-1.5,6.78-9.51,2.11,1.51,31.94,22.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    x: 0.86,
    y: 53.66,
    width: 37.73,
    height: 12.94,
    transform: "translate(80.13 79) rotate(125.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M109.79,40.16c-46.52,0-84.24,37.72-84.24,84.24s37.72,84.24,84.24,84.24,84.25-37.71,84.25-84.24S156.32,40.16,109.79,40.16Zm0,149.44c-36,0-65.2-29.19-65.2-65.2S73.79,59.2,109.79,59.2s65.2,29.19,65.2,65.2-29.19,65.2-65.2,65.2Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.bdb3f6ba217c4ed846796daf2524bd88.svg";
export { ForwardRef as ReactComponent };